<template>
  <Layout v-if="$store.getters.user && $store.getters.user.length">
    <transition name="main" mode="out-in">
      <router-view/>
    </transition>
  </Layout>
  <router-view v-else />
</template>

<script>
require('@/assets/favicon.ico')
import Layout from './Layout.vue'

export default {
  name: 'App',
  components: {Layout},
}
</script>

<style lang="scss">
  //@import './assets/scss/fix';
  //@import './assets/scss/common';

  .main-enter-active, .main-leave-active {
    transition: opacity .3s, transform .3s;
  }
  .main-enter, .main-leave-to {
    opacity: 0;
    transform: rotateX(15deg);
  }
</style>


// WEBPACK FOOTER //
// src/App.vue